module.exports = __webpack_public_path__ + "media/npc_dota_hero_legion_commander.9257068c.webm";